@if (priceListIsNew()) {
  <p class="margin-top--1x text--warning text--strong">
    De redigerade priserna går först att redigera när prislistan är skapad.<br />
    Det går dock att rensa de redigerade priserna så de inte skapas på din nya
    prislista.
  </p>
}

<div class="top-row-container">
  @if (!priceListIsNew()) {
    @if (!editingOverwrittenPrices) {
      <button
        class="button primary-1 margin-top--2x"
        (click)="editingOverwrittenPrices = true"
      >
        Redigera
      </button>
    } @else {
      <button
        class="button primary-1 margin-top--2x"
        (click)="save()"
        [disabled]="agWithdrawalLimits?.invalid"
      >
        Spara
      </button>
      <button
        class="button primary-2 margin-top--2x"
        (click)="editingOverwrittenPrices = false"
      >
        Avbryt
      </button>
    }
  } @else {
    <button
      class="button primary-1 margin-top--2x"
      (click)="clearOverWritenPrices()"
    >
      Rensa redigerade priser
    </button>
  }

  <div class="filter-row-container">
    @if (publishers.length > 1) {
      <div class="filter-dropdown margin-left--2x">
        <woo-dropdown
          [items]="publishers"
          [(ngModel)]="selectedPublisher"
          name="selectedPublisher"
          inputId="select-publisher"
          labelText="Välj Publicist"
          notFoundText="Inga publicister hittades."
          [clearable]="true"
        ></woo-dropdown>
      </div>
    }

    <div class="filter-dropdown margin-left--2x">
      <woo-dropdown
        [items]="productFormatOptions"
        [(ngModel)]="selectedProductFormat"
        name="selectedProductFormat"
        inputId="select-productFormat"
        labelText="Välj Placeringspris"
        notFoundText="Inga Placeringspriser hittades."
        [clearable]="true"
      ></woo-dropdown>
    </div>

    <div class="filter-dropdown margin-left--2x">
      <woo-dropdown
        [items]="targetingOptions"
        [(ngModel)]="selectedTargetingType"
        name="selectedTargetingType"
        inputId="select-targeting"
        labelText="Välj Styrningspris"
        notFoundText="Inga styrningspriser hittades."
        [clearable]="true"
      ></woo-dropdown>
    </div>

    <div class="filter-dropdown margin-left--2x">
      <woo-dropdown
        [items]="localityOptions"
        [(ngModel)]="selectedLocalityType"
        name="selectedLocalityType"
        inputId="select-locality"
        labelText="Välj Geografipris"
        notFoundText="Inga geografipriser hittades."
        [clearable]="true"
      ></woo-dropdown>
    </div>
  </div>
</div>

@if (!editingOverwrittenPrices) {
  <price-row-container
    [priceListRows]="overWritenPrices()"
    [publishers]="publishers"
    [priceList]="priceList"
    [selectedPublisher]="selectedPublisher?.id"
    [selectedProductFormat]="selectedProductFormat?.key"
    [selectedTargetingType]="selectedTargetingType?.key"
    [selectedLocalityType]="selectedLocalityType?.key"
  ></price-row-container>
} @else {
  <edit-overwritten-price-row-container
    [priceListRows]="priceList.valid_prices"
    [publishers]="publishers"
    [priceList]="priceList"
    [selectedPublisher]="selectedPublisher?.id"
    [selectedProductFormat]="selectedProductFormat?.key"
    [selectedTargetingType]="selectedTargetingType?.key"
    [selectedLocalityType]="selectedLocalityType?.key"
    (onOverwrittenPricesUpdated)="overwrittenPricesUpdated()"
  ></edit-overwritten-price-row-container>

  <div class="margin-top--2x">
    <button
      class="button primary-1"
      (click)="save()"
      [disabled]="agWithdrawalLimits?.invalid"
    >
      Spara
    </button>
    <button
      class="button primary-2"
      (click)="editingOverwrittenPrices = false"
    >
      Avbryt
    </button>
  </div>
}
